module.exports = __webpack_public_path__ + "static/media/image_black.25d8e881.svg";